// extracted by mini-css-extract-plugin
module.exports = {"secondaryText":"SecondaryText_secondaryText___kEix"};